<div class="campaign-bulk-operations">
    <!-- Action Buttons -->
    <div class="bulk-actions flex gap-2 mb-4">
        <p-button
            label="Status ändern"
            icon="fa-solid fa-exchange-alt"
            [disabled]="selectedMembers.length === 0"
            (onClick)="openStatusChangeDialog()"
            severity="secondary">
        </p-button>

        <p-button
            label="Agent zuweisen"
            icon="fa-solid fa-user-plus"
            [disabled]="selectedMembers.length === 0"
            (onClick)="openAssignDialog()"
            severity="secondary">
        </p-button>

        <p-button
            label="Aus Kampagne entfernen"
            icon="fa-solid fa-user-minus"
            [disabled]="selectedMembers.length === 0"
            (onClick)="openRemovalDialog()"
            severity="danger">
        </p-button>

        <p-button
            label="Nicht kontaktieren markieren"
            icon="fa-solid fa-ban"
            [disabled]="selectedMembers.length === 0"
            (onClick)="openDncDialog()"
            severity="warn">
        </p-button>

        <p-button
            label="Verlauf anzeigen"
            icon="fa-solid fa-history"
            (onClick)="openHistoryDialog()"
            severity="info">
        </p-button>
    </div>

    <!-- Selection Count -->
    <div *ngIf="selectedMembers.length > 0" class="selection-info mb-3 text-primary font-semibold">
        <i class="fa-solid fa-check-circle mr-2"></i>
        {{ selectedMembers.length }} Mitglied(er) ausgewählt
    </div>
</div>

<!-- Bulk Status Change Dialog -->
<p-dialog
    header="Massen-Statusänderung"
    [(visible)]="showStatusChangeDialog"
    [modal]="true"
    [style]="{ width: '500px' }">
    <div class="flex flex-column gap-3">
        <div>
            <label class="font-semibold mb-2 block">Neuer Status</label>
            <p-select
                [options]="statusTypes"
                [(ngModel)]="selectedStatusType"
                optionLabel="name"
                placeholder="Status auswählen"
                styleClass="w-full">
            </p-select>
        </div>

        <div>
            <label class="font-semibold mb-2 block">Grund (optional)</label>
            <textarea
                pTextarea
                [(ngModel)]="operationReason"
                rows="3"
                class="w-full"
                placeholder="Grund für die Statusänderung eingeben">
            </textarea>
        </div>

        <div class="text-secondary">
            Dies aktualisiert den Status von {{ selectedMembers.length }} Mitglied(ern).
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button
            label="Abbrechen"
            severity="secondary"
            (onClick)="showStatusChangeDialog = false">
        </p-button>
        <p-button
            label="Statusänderung anwenden"
            icon="fa-solid fa-check"
            [loading]="busy"
            (onClick)="executeBulkStatusChange()">
        </p-button>
    </ng-template>
</p-dialog>

<!-- Bulk Assignment Dialog -->
<p-dialog
    header="Massenzuweisung"
    [(visible)]="showAssignDialog"
    [modal]="true"
    [style]="{ width: '500px' }">
    <div class="flex flex-column gap-3">
        <div>
            <label class="font-semibold mb-2 block">Agent zuweisen</label>
            <p-select
                [options]="agents"
                [(ngModel)]="selectedAgent"
                optionLabel="name"
                placeholder="Agent auswählen"
                styleClass="w-full">
            </p-select>
        </div>

        <div>
            <label class="font-semibold mb-2 block">Grund (optional)</label>
            <textarea
                pTextarea
                [(ngModel)]="operationReason"
                rows="3"
                class="w-full"
                placeholder="Grund für die Zuweisung eingeben">
            </textarea>
        </div>

        <div class="text-secondary">
            Dies weist {{ selectedMembers.length }} Mitglied(er) dem ausgewählten Agenten zu.
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button
            label="Abbrechen"
            severity="secondary"
            (onClick)="showAssignDialog = false">
        </p-button>
        <p-button
            label="Mitglieder zuweisen"
            icon="fa-solid fa-user-plus"
            [loading]="busy"
            (onClick)="executeBulkAssign()">
        </p-button>
    </ng-template>
</p-dialog>

<!-- Bulk Removal Dialog -->
<p-dialog
    header="Massen-Entfernung"
    [(visible)]="showRemovalDialog"
    [modal]="true"
    [style]="{ width: '500px' }">
    <div class="flex flex-column gap-3">
        <div class="p-message p-message-warn">
            <i class="fa-solid fa-exclamation-triangle mr-2"></i>
            Warnung: Die ausgewählten Mitglieder werden aus der Kampagne entfernt.
        </div>

        <div>
            <label class="font-semibold mb-2 block">Grund für Entfernung</label>
            <textarea
                pTextarea
                [(ngModel)]="operationReason"
                rows="3"
                class="w-full"
                placeholder="Grund für die Entfernung eingeben">
            </textarea>
        </div>

        <div class="text-secondary">
            Dies entfernt {{ selectedMembers.length }} Mitglied(er) aus der Kampagne.
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button
            label="Abbrechen"
            severity="secondary"
            (onClick)="showRemovalDialog = false">
        </p-button>
        <p-button
            label="Mitglieder entfernen"
            icon="fa-solid fa-user-minus"
            severity="danger"
            [loading]="busy"
            (onClick)="executeBulkRemoval()">
        </p-button>
    </ng-template>
</p-dialog>

<!-- Bulk Do Not Contact Dialog -->
<p-dialog
    header="Als 'Nicht kontaktieren' markieren"
    [(visible)]="showDncDialog"
    [modal]="true"
    [style]="{ width: '500px' }">
    <div class="flex flex-column gap-3">
        <div class="p-message p-message-warn">
            <i class="fa-solid fa-ban mr-2"></i>
            Warnung: Das Markieren von Mitgliedern als 'Nicht kontaktieren' verhindert zukünftige Kampagnen-Kontaktaufnahmen.
        </div>

        <div>
            <label class="font-semibold mb-2 block">Grund</label>
            <textarea
                pTextarea
                [(ngModel)]="operationReason"
                rows="3"
                class="w-full"
                placeholder="Grund für den DNC-Status eingeben">
            </textarea>
        </div>

        <div class="text-secondary">
            Dies markiert {{ selectedMembers.length }} Mitglied(er) als 'Nicht kontaktieren'.
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button
            label="Abbrechen"
            severity="secondary"
            (onClick)="showDncDialog = false">
        </p-button>
        <p-button
            label="Als DNC markieren"
            icon="fa-solid fa-ban"
            severity="warn"
            [loading]="busy"
            (onClick)="executeBulkDnc()">
        </p-button>
    </ng-template>
</p-dialog>

<!-- Operation History Dialog -->
<p-dialog
    header="Massen-Operationsverlauf"
    [(visible)]="showHistoryDialog"
    [modal]="true"
    [style]="{ width: '900px' }">
    <p-table [value]="operationHistory" [loading]="busy" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>ID</th>
                <th>Typ</th>
                <th>Status</th>
                <th>Gesamt</th>
                <th>Erfolgreich</th>
                <th>Fehlgeschlagen</th>
                <th>Gestartet</th>
                <th>Aktionen</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-op>
            <tr>
                <td>{{ op.id }}</td>
                <td>{{ getOperationTypeLabel(op.operationType) }}</td>
                <td>
                    <p-tag [severity]="getOperationStatusSeverity(op.operationStatus)">
                        {{ getOperationStatusLabel(op.operationStatus) }}
                    </p-tag>
                </td>
                <td>{{ op.totalItems }}</td>
                <td class="text-green-600">{{ op.successCount }}</td>
                <td class="text-red-600">{{ op.failureCount }}</td>
                <td>{{ op.startedAt | date:'short' }}</td>
                <td>
                    <p-button
                        icon="fa-solid fa-list"
                        [text]="true"
                        pTooltip="Einträge anzeigen"
                        (onClick)="viewOperationItems(op)">
                    </p-button>
                    <p-button
                        *ngIf="op.failureCount > 0"
                        icon="fa-solid fa-exclamation-circle"
                        [text]="true"
                        severity="danger"
                        pTooltip="Fehlgeschlagene Einträge anzeigen"
                        (onClick)="viewFailedItems(op)">
                    </p-button>
                    <p-button
                        *ngIf="op.operationStatus === BulkOperationStatusEnum.pending"
                        icon="fa-solid fa-times"
                        [text]="true"
                        severity="secondary"
                        pTooltip="Abbrechen"
                        (onClick)="cancelOperation(op)">
                    </p-button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="text-center text-secondary">
                    Keine Massen-Operationen für diese Kampagne gefunden.
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<!-- Operation Items Dialog -->
<p-dialog
    header="Operationseinträge"
    [(visible)]="showItemsDialog"
    [modal]="true"
    [style]="{ width: '800px' }">
    <div *ngIf="selectedOperation" class="mb-3">
        <span class="font-semibold">Operation #{{ selectedOperation.id }}</span> -
        {{ getOperationTypeLabel(selectedOperation.operationType) }}
    </div>

    <p-table [value]="operationItems" [loading]="busy" styleClass="p-datatable-sm" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
            <tr>
                <th>Mitglieds-ID</th>
                <th>Status</th>
                <th>Verarbeitet am</th>
                <th>Fehler</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.campaignMemberId }}</td>
                <td>
                    <p-tag [severity]="getItemStatusSeverity(item.itemStatus)">
                        {{ getItemStatusLabel(item.itemStatus) }}
                    </p-tag>
                </td>
                <td>{{ item.processedAt | date:'short' }}</td>
                <td class="text-red-600">{{ item.errorMessage }}</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<!-- Failed Items Dialog -->
<p-dialog
    header="Fehlgeschlagene Einträge"
    [(visible)]="showFailedItemsDialog"
    [modal]="true"
    [style]="{ width: '800px' }">
    <div *ngIf="selectedOperation" class="mb-3">
        <span class="font-semibold">Operation #{{ selectedOperation.id }}</span> -
        {{ selectedOperation.failureCount }} fehlgeschlagene(r) Eintrag/Einträge
    </div>

    <p-table [value]="operationItems" [loading]="busy" styleClass="p-datatable-sm" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
            <tr>
                <th>Mitglieds-ID</th>
                <th>Fehlermeldung</th>
                <th>Verarbeitet am</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.campaignMemberId }}</td>
                <td class="text-red-600">{{ item.errorMessage }}</td>
                <td>{{ item.processedAt | date:'short' }}</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
